import { GlobalStatus, InspectionStatusEnum } from "@gtpl/shared-models/common-models";
import { BaseEntity, Column, Entity, Index, JoinColumn, JoinTable, ManyToMany, ManyToOne, OneToMany, OneToOne, PrimaryColumn, PrimaryGeneratedColumn, RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";
import { SoInvoiceDetails } from "./sale-invoice-details.entity";
import { SaleOrderItems } from "./sale-order-items.entity";
import { SaleOrder } from "./sale-order.entitiy";

@Entity('so_inspection')
export class SaleInspectionDetails {

  @PrimaryGeneratedColumn("increment", { name: 'so_inspection_id' })
  SoInspectionId: number;

  @Column("date", {
    nullable: true,
    name: "shipment_date"
  })
  shipmentDate: Date;

  @Column("date", {
    nullable: true,
    name: "initiation_date"
  })
  initiationDate: Date;

  @Column("date", {
    nullable: true,
    name: "planned_date"
  })
  plannedDate: Date;

  @Column("date", {
    nullable: true,
    name: "actual_date"
  })
  actualDate: Date;

  @Column("date", {
    nullable: true,
    name: "expected_result_date"
  })
  expectedResultDate: Date;

  @Column("varchar", {
    nullable: false,
    length: 100,
    name: "inspection"
  })
  inspectionName: string;

  @Column({
    type: 'enum',
    nullable: false,
    enum: GlobalStatus,
    default: GlobalStatus.NO,
    name: "is_checked"
  })
  isChecked: GlobalStatus;

  @Column("boolean", {
    nullable: false,
    default: false,
    name: "is_sgs_tuv"
  })
  isSgsTuv: boolean;

  @Column("int", {
    nullable: false,
    name: "sale_order_id"
  })
  saleOrderId: number;

  @Column({
    type:'enum',
    nullable:false,
    enum: InspectionStatusEnum,
    default:InspectionStatusEnum.OPEN,
    name:'inspection_status'
  })
  inspectionStatus:InspectionStatusEnum;

  @Column("boolean", {
    nullable: false,
    default: true,
    name: "is_active"
  })
  isActive: boolean;

  @CreateDateColumn({
    name: "created_at",
    type: "datetime"
  })
  createdAt: Date;

  @Column("varchar", {
    nullable: false,
    default: "Admin",
    name: "created_user"
  })
  createdUser: string | null;


  @UpdateDateColumn({
    name: "updated_at",
    type: 'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "updated_user"
  })
  updatedUser: string | null;

  @VersionColumn({
    default: 1,
    name: "version_flag"
  })
  versionFlag: number;

  @ManyToOne(type => SaleOrder, saleOrder => saleOrder.SoInspectionDetailsInfo, { nullable: false })
  @JoinColumn({ name: "sale_order_id" })
  saleOrderInfo: SaleOrder;
}
